// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ol.breadcrumb[data-v-58d82cf9] {\n  transform: translate(2px, 8px);\n}", ""]);
// Exports
module.exports = exports;
